<template>
    <!-- 升学途径 (体育类专业)-->
    <div class="sports_major">
        <div class="banner">
            <img src="/imgs/wayToStudy/main/banner.png" alt="">
        </div>
        <div class="main">
            <h6 class="main_title">体育类招生介绍</h6>
            <div class="main_box">
                <p>体育类专业招生主要是指普通高校体育类专业(即体育教育、社会体育指导与管理、休闲体育等专业)的招生。凡符合普通高校招生报考条件，具有一定体育专长的考生，都可报名参加体育类专业招生。</p>
            </div>    
        </div>
        <div class="main">
            <h6 class="main_title">招生专业有哪些？</h6>
            <div class="main_box">
                <p>体育教育、社会体育指导与管理、休闲体育等专业</p>
            </div>
        </div>
        <div class="main">
            <h6 class="main_title">报考条件是什么？</h6>
            <div class="main_box">
                <p>符合当年普通高考报名条件，身体健康，热爱体育事业，有一定的体育运动基础。男生身高不得低于1.70米，女生身高不得低于1.60米，任何一眼裸眼视力不得低于4.7，年龄不超过22周岁，未婚。（北京）</p>
                <p>其他省份生源可参照本省考试院公布的相关政策。</p>
            </div>
        </div>
        <div class="main">
            <h6 class="main_title">关于考试</h6>
            <div class="main_box">
                <p>除了参加普通高考文化课考试外，一般还要参加所在省(市、区)组织的体育类专业考试并取得合格成绩。</p>
                <p>体育类专业考试一般包括身体素质考试项目(100米跑、原地推铅球、800米跑等)和专项技术考试项目(田径、篮球、排球、足球、网球、羽毛球、乒乓球、体操、武术、游泳等)。部分省市还会组织面试。</p>
                <p>报考运动人体科学、体育经济与管理、新闻学(体育新闻方向)等专业的考生一般不必参加体育专业考试和面试，但须具备一定的体育运动基础。详见各省(市、区)当年体育类招生规定、办法等。</p>
            </div>
        </div>
        <div class="main">
            <h6 class="main_title">录取要求</h6>
            <div class="main_box">
                <p>体育类本科专业一般在提前进行录取;体育类高职(专科)专业一般在高职(专科)提前批中进行录取。(各省批次设置有差异)报考运动人体科学、体育经济与管理、新闻学(体育新闻方向)等专业的考生要特别注意这些专业所在批次。(以生源所在省级招办公布的当年《普通高等学校招生专业目录》为准。</p>
            </div>
        </div>
        <div class="remind main">
            <h6 class="main_title">特别提醒</h6>
            <div class="main_box">
                <p><span>1</span>在招生院校原则上依据本校录取率确定分项目招生计划数，上线考生依据填报的志愿梯次顺序，按照综合分由高到低，优先录取一志愿，未完成招生计划的院校，再录取二志愿。</p>
                <p><span>2</span>考生若已被运动训练、武术与民族传统体育专业录取，则不再参加普通高考及高校高水平运动队的录取。</p>
            </div>   
        </div>
        <div class="universities main">
            <h6 class="main_title">
                招生院校信息 
                <span>*由于各方面条件不断调整变化，请考生以各省考试院公布的最新消息为主</span>
            </h6> 
            <div class="school_box">
                <ul class="shengnei">
                    <li  v-for="(item, index) in sportUniversitys" :key="index" @click="goUniversity(item)">{{item}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {
            // 综合评价与自主招生的区别
            zonghepingjia: [
                { title: "综合评价的时间是定在高考之后且高考成绩处分之后，目的是为了参考高考成绩这一硬性指标来筛选面试学生。" },
                { title: "综合评价除了高考成绩之外，还要参考考生高中的综合素质评价信息，即高校更加注重考生的综合素质" },
                { title: "综合评价是先参加高考，再通过学校自己划定的高考面试线参加笔试或面试，最后合成最总成绩筛选出最终的人选" },
                { title: "综合评价招生是把考生的综合综合素质评价、高校的自测评估成绩、高考成绩按照一定比例折算成综合分，最后按照综合分择优录取" }
            ],
            zizhuzhaosheng: [
                { title: '自主招生的时间安排在高考前' },
                { title: '自主招生主要以选拔偏才怪才为主，注重学科特长和创新潜质能力' },
                { title: '自主招生通过初审后，还要参加各个大学自己组织的笔试+面试，通过面试后，可以获得各种高考分数优惠政策' },
                { title: '通过高校自主招生测试的考生，高校可以给予一定的优惠分值，一般情况下，可以降10-60分不等，部分高校甚至可以降低至一本线破格录取' },
            ],

            // 体育类招生
            sportUniversitys: ["北京师范大学", "普洱学院", "南京师范大学中北学院", "河南科技学院", "广东第二师范学院", "牡丹江师范学院天津师范大学", "西藏民族大学", "湖北科技学院", "周口师范学院", "南昌师范学院", "哈尔滨体育学院", "天津师范大学", "西藏民族大学", "湖北科技学院", "周口师范学院", "南昌师范学院", "哈尔滨体育学院", "河北北方学院", "陕西师范大学", "六盘水师范学院", "许昌学院", "成都理工大学", "上海师范大学", "保定学院", "宝鸡文理学院", "沈阳大学", "洛阳师范学院", "河北工程大学", "苏州大学", "唐山师范学院", "渭南师范学院", "潍坊学院", "长江大学", "池州学院", "南通大学", "衡水学院", "西北师范大学", "江汉大学", "湖北大学", "湖北经济学院", "江苏师范大学", "邯郸学院", "陇东学院", "广州大学", "黄冈师范学院", "武汉商学院", "盐城师范学院", "沧州师范学院", "河西学院", "西安文理学院", "湖北文理学院", "河北传媒学院", "浙江大学", "太原理工大学", "青海师范大学", "扬州大学", "湖北工程学院", "北京师范大学珠海分校", "杭州师范大学", "太原师范学院", "宁夏大学", "大连大学", "湖南科技大学", "成都文理学院", "绍兴文理学院", "晋中学院","石河子大学", "龙岩学院", "湖南师范大学", "郑州成功财经学院", "温州大学", "运城学院", "喀什大学", "玉溪师范学院", "湘南学院", "太原工业学院", "安徽师范大学", "内蒙古科技大学", "河北科技师范学院", "昆明学院", "邵阳学院", "常州大学", "安庆师范大学", "内蒙古民族大学", "呼伦贝尔学院", "安康学院", "湖南文理学院", "广东海洋大学", "皖西学院", "辽宁师范大学", "黄淮学院", "集宁师范学院", "湖南人文科技学院", "青岛科技大学", "宿州学院", "鞍山师范学院", "福建师范大学协和学院", "莆田学院", "广州中医药大学", "广州大学松田学院", "淮南师范学院", "延边大学", "成都信息工程大学银杏酒店管理学院", "湖南城市学院", "韶关学院", "四川旅游学院", "集美大学", "北华大学", "三亚学院", "广西科技师范学院", "韩山师范学院", "淮海工学院", "宁德师范学院", "吉林师范大学", "贵州医科大学", "甘肃民族师范学院", "肇庆学院", "贵州师范大学", "闽南师范大学", "白城师范学院", "海口经济学院", "宁波大学", "广州体育学院", "铜仁学院", "华东交通大学", "佳木斯大学", "河南理工大学", "海南师范大学", "广西师范大学", "安顺学院","南昌航空大学", "齐齐哈尔大学", "黄山学院", "呼和浩特民族学院", "广西民族师范学院", "凯里学院", "江西师范大学", "哈尔滨学院", "江苏科技大学", "黄河科技学院", "玉林师范学院", "贵州民族大学", "宜春学院", "绥化学院", "江西财经大学", "九江学院", "百色学院", "云南农业大学", "郑州升达经贸管理学院", "华东师范大学", "北京化工大学", "湖南工业大学科技学院", "西南石油大学", "大理大学", "天津中医药大学", "上海体育学院", "太原科技大学", "湖南文理学院芙蓉学院", "西华大学", "昭通学院", "中北大学", "中国矿业大学", "山西财经大学", "吉首大学张家界学院", "西昌学院", "集美大学诚毅学院", "东北大学", "南京师范大学", "辽宁石油化工大学", "南昌理工学院", "西南大学", "河南科技学院新科学院", "沈阳化工大学", "淮阴师范学院", "渤海大学", "湖北民族学院科技学院", "重庆师范大学", "重庆人文科技学院", "吉林大学", "南京体育学院", "东北电力大学", "华东交通大学理工学院", "绵阳师范学院", "山西财经大学华商学院", "燕山大学", "浙江师范大学", "江西理工大学", "江西师范大学科学技术学院", "宜宾学院", "沈阳科技学院", "西南医科大学", "湖州师范学院", "山东大学", "信阳学院", "重庆三峡学院", "广西民族大学相思湖学院", "河南农业大学", "台州学院", "山东农业大学", "太原理工大学现代科技学院", "阿坝师范学院", "西安财经学院行知学院", "中南民族大学", "丽水学院", "山东财经大学", "吉林师范大学博达学院", "乐山师范学院", "燕京理工学院", "云南大学滇池学院", "阜阳师范学院", "郑州轻工业学院", "广西师范大学漓江学院", "贵州大学", "井冈山大学", "广西大学", "淮北师范大学", "中国地质大学(武汉)", "贵州民族大学人文科技学院", "遵义师范学院", "山东理工大学", "西南科技大学", "滁州学院", "中南林业科技大学", "黑河学院", "兴义民族师范学院", "曲阜师范大学", "西南民族大学", "巢湖学院", "广西科技大学", "南京师范大学泰州学院", "贵州工程应用技术学院", "德州学院", "遵义医学院", "华侨大学", "重庆邮电大学", "湖北第二师范学院", "黔南民族师范学院", "鲁东大学", "西安石油大学", "福建师范大学", "山东中医药大学", "齐鲁师范学院", "云南大学", "泰山学院", "华北科技学院", "泉州师范学院", "西安建筑科技大学", "重庆第二师范学院", "西南林业大学", "菏泽学院", "江西警察学院", "南昌大学", "长安大学", "陕西学前师范学院", "云南师范大学", "郑州大学", "佛山科学技术学院", "东华理工大学", "陕西理工大学", "张家口学院", "曲靖师范学院", "山西大学商务学院", "湖南农业大学东方科技学院", "景德镇陶瓷大学", "萍乡学院", "首都体育学院", "保山学院", "山西师范大学现代文理学院", "江汉大学文理学院", "上饶师范学院", "徐州工程学院", "中央民族大学", "云南民族大学", "云南师范大学文理学院", "宁波大学科学技术学院", "赣南师范大学", "东莞理工学院", "天津体育学院", "西安工业大学", "广西师范学院师园学院", "湖州师范学院求真学院", "济南大学", "湖南涉外经济学院","河北师范大学", "延安大学", "贵州师范大学求是学院", "南昌工学院", "山东师范大学", "武汉生物工程学院", "河北民族师范学院", "咸阳师范学院", "长沙师范学院", "湖南理工学院", "聊城大学", "湖南师范大学树达学院", "廊坊师范学院", "西安体育学院", "合肥师范学院", "衡阳师范学院", "滨州学院", "闽南理工学院", "石家庄学院", "兰州城市学院", "贵州师范学院", "怀化学院", "临沂大学", "辽宁理工学院", "邢台学院", "天水师范学院", "海南热带海洋学院", "湖南科技学院", "济宁学院", "杭州师范大学钱江学院", "山西大学", "西北民族大学", "河北体育学院", "暨南大学", "山东体育学院", "宁夏大学新华学院", "山西师范大学", "青海民族大学", "三明学院", "华南师范大学", "河南科技大学", "云南师范大学商学院", "山西大同大学", "宁夏师范学院", "江西科技师范大学", "惠州学院", "河南大学", "江西理工大学应用科学学院", "长治学院", "新疆师范大学", "楚雄师范学院", "岭南师范学院","信阳师范学院", "安阳学院", "忻州师范学院", "伊犁师范学院", "榆林学院", "嘉应学院", "安阳师范学院", "郑州工商学院", "内蒙古师范大学", "吕梁学院", "北方民族大学", "深圳大学", "南阳师范学院", "太原科技大学华科学院", "赤峰学院", "枣庄学院", "南京晓庄学院", "广西师范学院", "商丘师范学院", "安徽师范大学皖江学院", "沈阳师范大学", "平顶山学院", "新余学院", "河池学院", "华中师范大学", "广东理工学院", "沈阳体育学院", "贵阳学院", "湖南工业大学", "广西民族大学", "湖北师范大学", "四川工业科技学院", "东北师范大学", "昌吉学院", "文山学院", "重庆大学", "湖北民族学院", "北京航空航天大学北海学院", "通化师范学院", "青岛大学", "钦州学院", "四川理工学院", "武汉体育学院", "辽宁财贸学院", "长春师范大学", "新乡学院", "广东石油化工学院", "四川农业大学", "吉首大学", "云南工商学院", "吉林体育学院", "三峡大学", "四川民族学院", "成都中医药大学", "湖南农业大学", "商丘学院", "哈尔滨师范大学", "成都学院", "重庆工商大学", "四川师范大学", "武汉体育学院体育科技学院", "衡阳师范学院南岳学院", "四川文理学院", "贺州学院", "西华师范大学", "成都体育学院", "景德镇陶瓷大学科技艺术学院", "郑州科技学院", "长江师范学院", "湖南第一师范学院", "内江师范学院", "重庆文理学院", "江西科技师范大学理工学院", "郑州师范学院", "湖南科技大学潇湘学院"]

        }
    },
    methods: {
        goUniversity(id) {
            var id = id;
            let {href}=this.$router.resolve({
                path: '/explore/yuanxiaoxiangqing',
                name: '院校详情',
                query: {
                    id: id,
                }
            })
            // window.open(href, '_blank');
             this.$router.push('/explore/yuanxiaoxiangqing?id='+id)
        },
        // 获取自招院校，省内是1，全部是2
        getZizhuzhaoshengList() {
            var _this = this;
            var token = window.sessionStorage.getItem('ymtxToken');
            this.$ajax
                .post(this.G_uri + '/target/getGroupZizhuzhaoshengList', {
                    token: token
                },{
                    headers:{
                        token: token
                    }
                })
                // 监听数据返回
                .then(function(res) {
                    _this.universityData = res.data.data[2];
                    _this.universityShengnei = res.data.data[1];
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
    },
    created() {
        this.getZizhuzhaoshengList();
    }
}
</script>
<style type="text/css" lang='less' scoped>
.sports_major {
    box-sizing: border-box;
    width: 970px;
    background-color: #fff;
    padding: 20px;
    .banner {
        width: 100%;
        // height: 212px;
    }
    .main {
        padding-top: 40px;
    }
    .main_title {
        line-height: 40px;
        text-align: left;
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 20px;
        padding-left: 40px;
        background: url(/imgs/wayToStudy/common/icon_title.png) no-repeat 0px center;
    }
    .main_box {
        p {
            line-height: 24px;
            font-size: 14px;
            color: #666;
            margin-bottom: 10px;
        }
    }   
    .zizhaoliucheng {
        ul {
            display: flex;
            li {
                flex: 1;

            }
        }
    }
    .remind {
        .main_box {
            p {
                span {
                    display: inline-block;
                    width: 24px;
                    height: 24px;
                    line-height: 24px;
                    text-align: center;
                    border-radius: 50%;
                    background-color: #2c8ffc;
                    color: #fff;
                    vertical-align: middle;
                    margin-right: 6px;
                    font-size: 12px;
                }
            }
        }

    }
    .universities {
        .main_title {
            span {
                font-size: 14px;
                color: red;
            }
        }
        .school {
            background: #60badf;
            color: #fff;
            line-height: 50px;
            text-align: center;
            border: 1px solid #60badf;
        }
        .province_school {
            text-align: center;
            line-height: 50px;
            font-size: 16px;
            border-bottom: 1px solid #eaeaea;
        }
        ul {
            overflow: hidden;
            width: 933px;
            li {
                font-size: 14px;
                box-sizing: border-box;
                float: left;
                width: 25%;
                border: 1px solid #eaeaea;
                margin-left: -1px;
                margin-top: -1px;
                min-height: 42px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 20px;
                text-align: center;
                &:nth-child(4n+1) {
                    margin-left: 0px;
                }
                &:nth-child(-n + 4) {
                    margin-top: 0px;
                }
                &:nth-child(8n-1),&:nth-child(8n-2),&:nth-child(8n-3),&:nth-child(8n) {
                    background-color: #e6f8ff;
                }
            }
        }
    }
}
</style>